import {
    KEY_PHONE_NUMBER_FIELD_VALIDATION_ERROR,
    KEY_PHONE_NUMBER_FIELD_VALIDATION_ERROR_NOT_AUTH,
    PHONE_NUMBER_VALIDATION_ERROR,
} from '~/src/models/constants/bad-request-errors.constants';
import { BAD_REQUEST_CODE } from '~/src/models/constants/status-codes';
import { generatePopupId } from './generate-popup-id';
import { LEAD_NOT_AUTH_POPUP_ERROR, PAGE_CONTEXT, POPUP_ERROR, TYPE_ERROR_ACTION } from '../constants';
import type { ExtendedAxiosResponse, InternalDataFieldInterface } from '~/src/models/types/axios-response.types';
import type { ErrorConfig, PopupHandlers } from '../types/error-handlers.types';

export const badRequestHandler = (
    error: ExtendedAxiosResponse<InternalDataFieldInterface>,
    page: (typeof PAGE_CONTEXT)[keyof typeof PAGE_CONTEXT],
    analyticsCallback?: () => void,
    handlers?: PopupHandlers,
): ErrorConfig => {
    const inputFieldErrors = error?.response?.data?.inputFieldErrors;
    const message = error?.response?.data?.message;
    const [firstFieldError] = Object.values(inputFieldErrors || {});
    const [keyFirstFieldError] = Object.keys(inputFieldErrors || {});
    const isPhoneValidationError =
        keyFirstFieldError === KEY_PHONE_NUMBER_FIELD_VALIDATION_ERROR ||
        keyFirstFieldError === KEY_PHONE_NUMBER_FIELD_VALIDATION_ERROR_NOT_AUTH;
    const phoneFieldError = isPhoneValidationError
        ? {
            field: keyFirstFieldError,
            message: firstFieldError || PHONE_NUMBER_VALIDATION_ERROR,
        }
        : undefined;

    if (isPhoneValidationError && !firstFieldError?.length) {
        return {
            action: {
                type: TYPE_ERROR_ACTION.popup,
                config: POPUP_ERROR[page].phoneValidationError,
                popupId: generatePopupId(page, BAD_REQUEST_CODE),
                handlers,
            },
            effects: {
                analyticsCallback,
                fieldError: phoneFieldError,
            },
        };
    }

    if (firstFieldError?.length) {
        return {
            action: {
                type: TYPE_ERROR_ACTION.popup,
                config: POPUP_ERROR[page].validationError(firstFieldError),
                popupId: generatePopupId(page, BAD_REQUEST_CODE),
                handlers,
            },
            effects: {
                analyticsCallback,
                fieldError: phoneFieldError,
            },
        };
    }

    if (message?.length) {
        return {
            action: {
                type: TYPE_ERROR_ACTION.popup,
                config: POPUP_ERROR[page].validationError(message),
                popupId: generatePopupId(page, BAD_REQUEST_CODE),
                handlers,
            },
            effects: {
                analyticsCallback,
            },
        };
    }

    return {
        action: {
            type: TYPE_ERROR_ACTION.popup,
            config: LEAD_NOT_AUTH_POPUP_ERROR,
            popupId: generatePopupId(page, BAD_REQUEST_CODE),
            handlers,
        },
        effects: {
            analyticsCallback,
        },
    };
};
